import { render, staticRenderFns } from "./UserLPS.vue?vue&type=template&id=9b00a80c"
import script from "./UserLPS.vue?vue&type=script&lang=js"
export * from "./UserLPS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports